'use strict';

var MeshRendererController = function MeshRendererController($scope, $element, $templateCache, $compile, $sce) {
  this.iframe = $element[0].querySelector('iframe').contentWindow;

  this.currentScene = null;
  this._iframeReady = false;

  this.iframeUrl = $sce.trustAsResourceUrl('/mesh');

  this.init = function init() {
    this.startTime = performance.now();
  };

  //bound in the directive
  this._handleSceneChange = function _handleSceneChange(newSceneDescriptor) {
    //send new scene to iframe app
    this.currentScene = newSceneDescriptor;
    if(this._iframeReady){
      this._sendCurrentScene();
    }
  };

  this._handleMessage = function _handleMessage(ev) {

    switch (ev.data) {
      case 'iframe_ready':
        this._iframeReady = true;
        this._sendCurrentScene();
      break;
    }

  };

  this._sendCurrentScene = function _sendCurrentScene() {
    if(this.currentScene){
      this.iframe.postMessage({
        type: 'new_scene',
        data: this.currentScene
      }, '*');
    }
  };

  $scope.$on("$destroy", function() {
    var end =  performance.now(),
        seconds = (end - this.startTime)/1000.0;

    window.top.postMessage({
      eventData: {
        seconds: seconds.toFixed(2),
      },
      eventType: 'timeSpent',
      src: 'analytics'
    }, '*');
  }.bind(this));

  window.addEventListener('message', this._handleMessage.bind(this));
};

module.exports = MeshRendererController;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/meshRenderer/src/MeshRendererController.js